module.exports = __webpack_public_path__ + "img/features-4-dashboard.98877715.png";